import i18n from 'i18next';

export const dataUsageColumns = [
  {
    id: 'vehicle',
    numeric: false,
    disablePadding: true,
    label: i18n.t('camera.vehicle'),
    needSorting: true,
  },
  {
    id: 'camera_serial_no',
    numeric: false,
    disablePadding: true,
    label: i18n.t('camera.camera_serial_no'),
    needSorting: true,
  },
  {
    id: 'data_usage',
    numeric: false,
    disablePadding: true,
    label: i18n.t('camera.tabs.dataUsage'),
    needSorting: true,
  },
  {
    id: 'cycle',
    numeric: false,
    disablePadding: true,
    label: i18n.t('camera.cycle'),
    needSorting: true,
  },
];

export const columns = [
  {
    id: 'vehicle',
    numeric: false,
    disablePadding: true,
    label: i18n.t('camera.vehicle'),
    needSorting: true,
  },
  {
    id: 'camera_serial_no',
    numeric: true,
    disablePadding: false,
    label: i18n.t('camera.camera_serial_no'),
    needSorting: true,
  },
  {
    id: 'event_type',
    numeric: false,
    disablePadding: false,
    label: i18n.t('camera.event_type'),
    needSorting: true,
  },
  {
    id: 'event_level',
    numeric: true,
    disablePadding: false,
    label: i18n.t('camera.event_level'),
    needSorting: true,
  },
  {
    id: 'date',
    numeric: false,
    disablePadding: false,
    label: i18n.t('camera.date'),
    needSorting: true,
  },
  {
    id: 'actions',
    label: i18n.t('Actions'),
  },
];

export const sortColumnMapping = {
  unitId: 'vehicleName',
  work_order_id: 'idPub',
  type: 'unitType',
  reported_date: 'createDate',
  scheduled_date: 'beginDate',
  due_date: 'endDate',
  workOrderType: 'type',
  status: 'state',
  date: 'startTime',
  vehicle: 'vehicleName',
  camera_serial_no: 'cameraSN',
  event_type: 'eventType',
  event_level: 'eventLevel',
  time: 'uploadTime',
  data_usage: 'dataUsageInKB',
  cycle: 'cycle',
};

export const basicRequest = {
  displayStart: 1,
  displayLength: 10,
};
